import { DeleteVideo, UpdateVideo } from "../../redux/videos";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { VideoForm } from "./VideoForm";
import styled from "styled-components";

export const VideoEdits = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { loading, error } = useSelector((state) => state.videos);

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateVideo(state.video.id, values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/gallery/videos");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteVideo(state.video));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/gallery/videos");
      }, 500);
    }
  };

  const InitialValues = state?.video;

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Section>
        <SubNav>
          <li onClick={onDeleteSubmit}>
            <IoTrash />
          </li>
        </SubNav>
        {error && <ErrorBanner text={error} />}

        <VideoForm initialValues={InitialValues} onFormSubmit={onFormSubmit} />
      </Section>
    </>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
